import axios from "axios";
import { ApiGeeAuthenticationResponse } from "./types";
import { GEARS_TOKEN, GEARS_TOKEN_EXPIRATION_DATE } from "@constants";

const sha512 = async (message: string): Promise<string> => {
  const msgBuffer = new TextEncoder().encode(message);
  const hashBuffer = await window.crypto.subtle.digest("SHA-512", msgBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
};

const headers = {
  Accept: "application/json",
  "Accept-Encoding": "gzip",
  "Content-Type": "application/x-www-form-urlencoded",
};

export const apiGeeAuthentication = async (): Promise<ApiGeeAuthenticationResponse | null> => {
  const gearsToken = process.env.REACT_APP_APIGEE_CLIENT_SECRET;
  const apiGeeUrl = process.env.REACT_APP_GEARS_API_GEE_URL;
  const appId = process.env.REACT_APP_API_APP_ID;
  const nonce = process.env.REACT_APP_NONCE;
  const hashedSecret = await sha512(`${nonce}${gearsToken}`);
  //console.log("check apigee: ");
  //console.log("gearsToken: " + gearsToken);
  if (gearsToken === null || gearsToken === "") {
    console.log(
      "You have to define environment variable REACT_APP_APIGEE_CLIENT_SECRET"
    );
    return null;
  }

  const pathname_login = window.location.pathname.split("/")[1];
  //console.info("pathname_login apigee:"+pathname_login);
  if (
    isTokenExpiratedOrNull() &&
    apiGeeUrl != null &&
    pathname_login !== "login"
  ) {
    // console.log("INSIDE IS NULL BLOCK");
    // console.log("isTokenExpiratedOrNull:" + isTokenExpiratedOrNull());
    try {
      const { data } = await axios.post<ApiGeeAuthenticationResponse>(
        `${apiGeeUrl}`,
        `app_id=${appId}&nonce=${nonce}&secret=${hashedSecret}&grant_type=client_credentials`,
        {
          headers,
        }
      );
      //console.info("generate new apigee token1:"+data.token);
      sessionStorage.setItem(GEARS_TOKEN_EXPIRATION_DATE, data.date_created);
      sessionStorage.setItem(GEARS_TOKEN, data.token);

      if (pathname_login !== "login") {
        // console.log("apigee redirect 1 " + pathname_login);
        window.location.href = `/login/r${window.location.pathname}`;
      } else {
        // console.log("apigee redirect 2 " + pathname_login);
        window.location.href = `/login`;
      }
      throw new axios.Cancel("Operation canceled by the user.");
      //return data;
    } catch (error) {
      throw error;
    }
  } else if (pathname_login === "login") {
    // console.log("INSIDE ELSE IF CONDITION: " + pathname_login);
    try {
      const { data } = await axios.post<ApiGeeAuthenticationResponse>(
        `${apiGeeUrl}`,
        `app_id=${appId}&nonce=${nonce}&secret=${hashedSecret}&grant_type=client_credentials`,
        {
          headers,
        }
      );
      //console.info("generate new apigee token2:");
      sessionStorage.setItem(GEARS_TOKEN_EXPIRATION_DATE, data.date_created);
      sessionStorage.setItem(GEARS_TOKEN, data.token);

      return data;
    } catch (error) {
      throw error;
    }
  }
  return null;
};

export function isTokenExpiratedOrNull(): boolean {
  const tokenSessionExpirationDate = sessionStorage.getItem(
    GEARS_TOKEN_EXPIRATION_DATE
  );
  const tokenGearsSession = sessionStorage.getItem(GEARS_TOKEN);

  if (tokenSessionExpirationDate === null || tokenGearsSession === null) {
    return true;
  } else {
    const actualDate = new Date();
    const tokenCreateDate = new Date(tokenSessionExpirationDate);
    const expireDate = new Date(tokenSessionExpirationDate);
    const expiryDate = new Date(Number(tokenSessionExpirationDate) * 1000);
    // console.info("tokenSessionExpirationDate:"+tokenSessionExpirationDate);
    // console.info("1expiryDate:"+expiryDate);
    expireDate.setHours(expireDate.getHours() + 1);
    //expireDate.setMinutes( expireDate.getMinutes());

    expiryDate.setHours(expiryDate.getHours() + 1);
    // console.info("2expireDate:"+expireDate);
    // console.info("correct expiryDate:"+new Date(expiryDate));
    const tokenExpirationDate = new Date(
      Number(tokenCreateDate) + 15 * 3600 * 1000
    );
    // console.info("actualDate:"+actualDate);
    // console.info("tokenExpirationDate:"+tokenExpirationDate);
    // console.log("actualDate conv:"+ new Intl.DateTimeFormat('en-US').format(actualDate))
    // console.log("tokenExpirationDate conv:"+new Intl.DateTimeFormat('en-US').format(tokenExpirationDate))
    // console.info("apigee is expired:"+(actualDate > tokenExpirationDate));
    // console.info("apigee is expired:"+(actualDate > expireDate));
    return actualDate > expireDate;
  }
}
